// extracted by mini-css-extract-plugin
export default {"NavWrapper":"Nav_NavWrapper__6prvl","Nav":"Nav_Nav__Vlqs3","Logo":"Nav_Logo__feSbH","Link":"Nav_Link__B46on","NavDropdownMenu":"Nav_NavDropdownMenu__7DfJ3"};